import {mergeProperties} from "../components/Utility";
import ActionDropdown from "../components/actions/ActionDropdown";
import Image from "../components/common/Image";
import React from "react";

export const getFormData = (data) => {
    const initialData = {
        name: '',
        image: '',
        status: '1',
        price: undefined,
        sellPrice: '',
        stock: '',
        tags: '',
        additionalDetails: {
            isVeg: true
        },
        description: '',
    }
    // fill data in initialData from data
    return mergeProperties(initialData, data);
};

export const getProductReportFormData = (data) => {
    const initialData = {
        startDate: '',
        endDate: '',
    }
    // fill data in initialData from data
    return mergeProperties(initialData, data);
};

export const getTableColumns = () => {
    let tableColumns = [
        {header: "Name", field: "name"},
        {header: "Tags", field: "tags"},
        {header: "Stock", field: "stock"},
        {header: "Sell Price", field: "sellPrice"},
        {header: "Availability", field: "availability"},
    ];

    tableColumns.push({
        header: 'Action',
        disableSorting: true,
        field: 'action',
        align: "right",
        render: (row) => {
            return <ActionDropdown row={row}/>;
        },
    });

    return tableColumns;
};

export const getTableData = ({items = []}) => {
    if (!Array.isArray(items)) return [];
    return items.map(item => ({
        id: item.id,
        productTemplate: item.productTemplate,
        tags: item?.tags.map(tag => tag.name).join(", "),
        restaurant: item.restaurant,
        price: item.price,
        stock: item.stock,
        sellPrice: item.sellPrice,
        availability: item.availability ? "Yes" : "No",
        variations: item.variations,
        name: item.name,
        image: item.image,
    }));
}

export const getDetailData = ({item}) => {
    if (!item) return {details: {}};
    return {
        details: {
            name: item.name,
            image: <Image className="border rounded-2" src={item.image} alt={item.name}/>,
            tags: item.tags.map(tag => tag.name).join(", "),
            price: item.price,
            sellPrice: item.sellPrice,
            stock: item.stock,
            isVeg: item.additionalDetails?.isVeg ? "Yes" : "No",
            availability: item.availability ? "Yes" : "No",
            status: item.status ? "Active" : "Inactive",
        }
    };
}


export const getProductReportTableColumns = () => {
    let tableColumns = [
        {header: "Name", field: "name"},
        {header: "Units Sold", field: "totalQuantity"},
        {header: "Avg. Unit Solds ", field: "averageQuantity"},
    ];

    return tableColumns;
};

export const getProductReportTableData = ({items = []}) => {
    if (!Array.isArray(items)) return [];
    return items.map(item => ({
        name: item.name,
        totalQuantity: item.totalQuantity,
        averageQuantity: item.averageQuantity
    }));
}